import React, { useState, useEffect } from 'react';
import './Gallery.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

const galleryVideos = [
  {
    title: "Corporate video",
    url: "https://www.youtube.com/embed/IHo3wJMxMDY"
  },

  {
    title: "Engagement Story",
    url: "https://www.youtube.com/embed/zQycTZ-GMVQ"
  },

  {
    title: "Baby Shower Memories",
    url: "https://www.youtube.com/embed/xD5l4ixYAWM"
  },

  {
    title: "Traditional Moments",
    url: "https://www.youtube.com/embed/o1kT_5tR6MA"
  },
  {
    title: "Corporate video",
    url: "https://www.youtube.com/embed/HZxmSMvDgZ0"
  },
  {
    title: "New Cinematic Wedding Video :- Professional Video Edited By R.D'S Creation's",
    url: "https://www.youtube.com/embed/b2-CsrMtzhU"
  },
  {
    title: "Wedding Cinematic Teaser",
    url: "https://www.youtube.com/embed/6cv8ES0xozY"
  },
  {
    title: "JILNA & NIKHIL Wedding :- Professional Video Edited By R.D'S Creation's",
    url: "https://www.youtube.com/embed/RVUFmdHw7JM"
  },
  {
    title: "Wedding Caricature Video 1",
    url: "https://www.youtube.com/embed/fs7TwCUDRcI"
  },
  {
    title: "HAPPY BIRTHDAY DIARA BIRTHDAY VIDEO :- VIDEO EDITED BY R.D'S CREATIONS.",
    url: "https://www.youtube.com/embed/W7l1LiOPBLQ"
  },
  {
    title: "Emotional Wedding Film",
    url: "https://www.youtube.com/embed/jn0OU2q3jSM"
  },
  {
    title: "Pre-Wedding Vibes",
    url: "https://www.youtube.com/embed/GlhhPIcMvs0"
  },
  {
    title:"Birthday Video",
    url: "https://www.youtube.com/embed/vz6m3DOkIlE"
  }
];
const Gallery = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const closeModal = () => setSelectedVideo(null);

  return (
    <section id="gallery" className="gallery-section" data-aos="fade-up">
      <h2 data-aos="fade-down">Gallery</h2>
      <div className="gallery-grid">
        {galleryVideos.map((video, index) => (
          <div
            className="gallery-item"
            key={index}
            onClick={() => setSelectedVideo(video.url)}
            data-aos="zoom-in"
            data-aos-delay={index * 100}
          >
            <div className="video-container">
              <iframe
                src={video.url}
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <h3>{video.title}</h3>
          </div>
        ))}
      </div>

      {selectedVideo && (
        <div className="fullscreen-overlay" onClick={closeModal}>
          <div className="fullscreen-video" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeModal}>×</button>
            <iframe
              src={selectedVideo + '?autoplay=1'}
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              title="Fullscreen Video"
            ></iframe>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;